export const thunkTypes = {
  SUBMIT_FAILED_DELIVERY: `failedDelivery/submit`,
  LOAD_ADDRESSES: `failedDelivery/loadAddresses`,
  LOAD_ZONES: `failedDelivery/loadZones`,
  LOAD_MAX_ATTEMPTS: `failedDelivery/loadMaxAttempts`,
};
